export default "__VITE_ASSET__CFPrTnDb__"